module.exports = __webpack_public_path__ + "img/Biermann2019.8e13f981.jpg";